import { SagaIterator } from 'redux-saga';
import { all, put, call, take, fork, debounce } from 'redux-saga/effects';
import GiphyApiClient from 'giphy-js-sdk-core';
import { reduxModuleLoaded } from '../actions/editor';
import {
  fetchGifs,
  fetchGifsSuccess,
  fetchGifsFailure,
} from '../actions/extension-gif';
import { draftsSaga } from '../../clientDrafts/saga';

const GIPHY_API_KEY = 'dCf5MVSF00OQO1mlKr5DoNPO9OpOrlhj';
const PAGE_SIZE = 25;
const SEARCH_TYPE = 'gifs';

function* handleFetchGifs(action: ReturnType<typeof fetchGifs>): SagaIterator {
  const { q, pg } = action.payload;
  const giphyClient = GiphyApiClient(GIPHY_API_KEY);
  let response;

  try {
    if (q) {
      response = yield call(giphyClient.search.bind(giphyClient), SEARCH_TYPE, {
        q,
        offset: pg * PAGE_SIZE,
        limit: PAGE_SIZE,
      });
    } else {
      response = yield call(
        giphyClient.trending.bind(giphyClient),
        SEARCH_TYPE,
        { limit: 100 }
      );
    }
    yield put(fetchGifsSuccess(response.data));
  } catch (e) {
    yield put(fetchGifsFailure);
  }
}

export function* moduleLoadableSaga() {
  yield take(reduxModuleLoaded);
  yield saga();
}

export default function* saga() {
  yield all([debounce(250, fetchGifs, handleFetchGifs), fork(draftsSaga)]);
}
